import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '../../routes/useQuery';
import { ReactComponent as ForbiddenIcon } from './ForbiddenIcon.svg';

const useStyles = makeStyles(theme => ({
  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  center: {
    textAlign: 'center',
  },
  root: {
    marginTop: theme.spacing(10),
  },
  goToOrg: {
    marginTop: theme.spacing(2),
  },
}));

const Forbidden = () => {
  const classes = useStyles();
  const { get } = useQuery();
  const isUpgradeBlocked = get('upgradeBlocked') === 'true';

  return (
    <Grid container justifyContent="center" className={classes.root}>
      <Grid item className={classes.center}>
        <ForbiddenIcon />
        <Typography variant="h2" className={classes.title}>
          <FormattedMessage id={isUpgradeBlocked
            ? 'forbidden.upgrade_blocked.title'
            : 'forbidden.access_denied'}
          />
        </Typography>
        <Typography variant="h3">
          <FormattedMessage id={isUpgradeBlocked
            ? 'forbidden.upgrade_blocked.explanation'
            : 'forbidden.explanation'}
          />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Forbidden;
